export default __webpack_public_path__ + "static/media/fennec.c3835d6d.webp";